<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',

}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  .c-header
  {
    background-color: #515151;
  }
  .c-header-nav-link
  {
    color: #fff !important;
  }
  .c-subheader
  {
    display: none;
  }
  .c-sidebar-brand > svg
  {
    display: none !important;
  }

</style>
